import $ from 'jquery'

const setupDependentSelects = (container) => {
  const $container = $(container);
  let options = {};
  try {
    options = JSON.parse($container.attr('data-options') || '{}');
  } catch (e) {
    options = {};
  }

  const locale = $container.attr('data-locale');

  const $one = $container.find('[data-dependent-selects-level="1"]');
  const $two = $container.find('[data-dependent-selects-level="2"]');
  const $three = $container.find('[data-dependent-selects-level="3"]');

  // Turns an option entry into { label, value }. Plain strings (org keys) map to
  // themselves; translated entries keep the canonical English `en` as the value
  // so the DB stores English, and use the current locale for the label (falling
  // back to English when the locale is missing).
  const localize = (item) => {
    if (typeof item === 'string') return { label: item, value: item };
    return { label: item[locale] || item.en, value: item.en };
  };

  const populate = ($select, items) => {
    const currentValue = $select.val();
    $select.find('option').not('[value=""]').remove();
    const localized = items.map(localize);
    localized.forEach(({ label, value }) => {
      $select.append(new Option(label, value));
    });
    if (localized.some((option) => option.value === currentValue)) {
      $select.val(currentValue);
    } else {
      $select.val('');
    }
  };

  const handleTwoChange = () => {
    const v1 = $one.val();
    const v2 = $two.val();
    const items = (options[v1] || {})[v2] || [];
    populate($three, items);
    $three.prop('disabled', items.length === 0);
  };

  const handleOneChange = () => {
    const v1 = $one.val();
    const items = Object.keys(options[v1] || {});
    populate($two, items);
    $two.prop('disabled', items.length === 0);
    handleTwoChange();
  };

  $one.on('change', handleOneChange);
  $two.on('change', handleTwoChange);
};

jQuery(document).on('turbolinks:load', () => {
  $('.dependent-selects-container').each((_i, node) => setupDependentSelects(node));
});
